import { createContext, ReactNode, useContext } from "react";
import { ClientPortalConfig } from "../types/generated/models";
import { useClientPortalConfig } from "../hooks/useClientPortalConfig";
interface IClientPortalConfigContext {
    clientPortalConfig: ClientPortalConfig | null;
    isLoading: boolean;
    clientPortalGuid: string;
}

interface IClientPortalConfigContextProps {
    clientPortalGuid: string;
}

const ClientPortalConfigContext = createContext<IClientPortalConfigContext>({
    clientPortalConfig: null,
    clientPortalGuid: "",
    isLoading: true,
});
ClientPortalConfigContext.displayName = "ClientPortalConfigContext";

export function ClientPortalConfigContextProvider({
    children,
    clientPortalGuid,
}: IClientPortalConfigContextProps & { children: ReactNode }) {
    const { data, isLoading } = useClientPortalConfig(clientPortalGuid);

    return (
        <ClientPortalConfigContext.Provider value={{ clientPortalConfig: data, isLoading, clientPortalGuid }}>
            {children}
        </ClientPortalConfigContext.Provider>
    );
}

export function useClientPortalConfigContext() {
    return useContext(ClientPortalConfigContext);
}
